import { createRoute, redirect } from "@tanstack/react-router";

import { canAccessAskPuntt, isDemoEnterprise } from "../../utils/auth";
import { askPunttRoute } from "../ask-puntt/route";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    // Demo tenants land on the Ask Puntt landing screen (Killer Demo
    // Flow Step 1) — the seeded "your 3 assets" panel + scripted
    // baseline responses live there. The legacy /home route stays
    // reachable for anyone who navigates to it directly, but `/` no
    // longer auto-routes demo users to it.
    if (isDemoEnterprise()) {
      throw redirect({ to: askPunttRoute.to });
    }
    throw redirect({
      to: canAccessAskPuntt() ? askPunttRoute.to : ticketsRoute.to,
    });
  },
});
